import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { AverageStat } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelM } from '@sorare/core/src/atoms/typography';
import { Switch } from '@sorare/core/src/components/search/Switch';
import { StatIcon } from '@sorare/core/src/components/stats/StatIcon';
import { Stats, statLabels } from '@sorare/core/src/lib/scoring';

import { DECISIVE_ACTIONS, STATISTICS } from 'lib/scoutingCenter';

const FootballStat = (stat: AverageStat) => ({
  value: stat,
  icon: <StatIcon statKey={stat.toLowerCase() as Stats} />,
  label:
    (statLabels[stat.toLowerCase() as keyof typeof statLabels] && (
      <FormattedMessage
        {...statLabels[stat.toLowerCase() as keyof typeof statLabels]}
      />
    )) ||
    stat.toLowerCase(),
});

const statistics = STATISTICS.map(FootballStat);
const decisiveActions = DECISIVE_ACTIONS.map(FootballStat);

const CapitalizeFirstLetter = styled.span`
  &::first-letter {
    text-transform: uppercase;
  }
`;

type Props = {
  stats: AverageStat[];
  onChange: (sort: AverageStat[]) => void;
};

export const FootballStats = ({ stats, onChange }: Props) => {
  return (
    <Vertical>
      <LabelM color="var(--c-nd-600)">
        <FormattedMessage
          id="searchCommonPlayer.statsManager.stats.football.title"
          defaultMessage="Statistics"
        />
      </LabelM>
      {statistics.map(({ value, icon, label }) => (
        <Switch
          key={value}
          label={
            <Horizontal>
              {icon} <CapitalizeFirstLetter>{label}</CapitalizeFirstLetter>
            </Horizontal>
          }
          checked={stats.some(v => v === value)}
          onChange={() =>
            onChange(
              stats.includes(value)
                ? stats.filter(v => v !== value)
                : [...stats, value]
            )
          }
        />
      ))}
      <LabelM color="var(--c-nd-600)">
        <FormattedMessage
          id="searchCommonPlayer.statsManager.stats.decisiveActions.title"
          defaultMessage="Decisive actions"
        />
      </LabelM>
      {decisiveActions.map(({ value, icon, label }) => (
        <Switch
          key={value}
          label={
            <Horizontal>
              {icon} <CapitalizeFirstLetter>{label}</CapitalizeFirstLetter>
            </Horizontal>
          }
          checked={stats.some(v => v === value)}
          onChange={() =>
            onChange(
              stats.includes(value)
                ? stats.filter(v => v !== value)
                : [...stats, value]
            )
          }
        />
      ))}
    </Vertical>
  );
};
